import { Fragment, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Iconify from 'src/components/iconify';
import { Box, Divider, IconButton, Modal, Tooltip } from '@mui/material';
import Snte from './subRows/Snte';
import VDebut from './subRows/VDebut';
import VCible from './subRows/VCible';
import ValuesRow from './subRows/ValuesRow';
import { style } from './RowEffect';
import { AreaEditMetrics } from 'src/components/Metrics/TextAreaEditMetrics';
import AloneHeader from '../details/AloneHeader';
import SubHeaderEffect from './SubHeaderEffect';
import TitleMetric from '../TtileMetric';
import SubHeader from './SubHeader';
import NbMetric from './subRows/NbMetric';

const RowProduct = ({ title, isVolet, data }: any) => {
  const [open, setOpen] = useState(false);
  const [extraData, setExtraData] = useState('');
  const [openProduct, setOpenProduct] = useState(false);
  const [targetMetric, setTargetMetric] = useState<any>(undefined);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div key={data?._id}>
      <Accordion
        sx={{
          border: '1px solid #2065d1',
          borderRadius: '4px',
          background: '#B3D4FC',
        }}
      >
        <AccordionSummary
          expandIcon={<Iconify icon="ep:arrow-up-bold" className="ml-2" width={16} />}
          sx={{
            flexDirection: 'row-reverse',
            color: '#2065d1',
            background: '#B3D4FC',
          }}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <div className="flex w-full items-center justify-between">
            <span>{data.title}</span>
            <IconButton
              size="small"
              color="inherit"
              onClick={() => {
                setExtraData(data.extraData || '');
                setOpenProduct(true);
              }}
              sx={{
                p: 0,
                color: 'text.secondary',
                height: '30px',
                width: '30px',
                marginTop: '5px',
              }}
            >
              <Iconify icon="ci:show" width={16} />
            </IconButton>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <SubHeader title={title} />
          {data.children.map((curr: any, index: number) => (
            <Fragment key={curr._id}>
              <div key={curr._id} className="flex gap-1">
                <div className="flex flex-col items-center justify-center min-w-[50px] w-[50px] border-r-2 text-thin text-xs">
                  {/* <span> {isVolet ? curr.nbV : curr.nb}</span> */}
                  <NbMetric
                    id={curr._id}
                    isVolet={isVolet}
                    initialData={isVolet ? curr.nbV : curr.nb}
                  />
                </div>
                {/* <Tooltip title={isVolet ? curr.titleV : curr.title}> */}
                <div className="min-w-[270px] text-thin text-xs w-[270px] border-r-2">
                  {/* {isVolet ? curr.titleV : curr.title} */}
                  <TitleMetric
                    id={curr._id}
                    isVolet={isVolet}
                    title={isVolet ? curr.titleV : curr.title}
                  />
                </div>
                {/* </Tooltip> */}
                <Snte id={curr._id} initialData={curr.snte} />
                <VDebut id={curr._id} data={curr.startv} />
                <VCible
                  id={curr._id}
                  data={
                    curr._id == '678ea549fa97173780bbb7fa' && !isVolet ? curr.ciblep : curr.ciblev
                  }
                  isSpecific={curr._id == '678ea549fa97173780bbb7fa' && !isVolet}
                />
                <ValuesRow id={curr._id} data={curr} />

                <IconButton
                  size="small"
                  color="inherit"
                  onClick={() => {
                    setTargetMetric(curr);
                    handleOpen();
                  }}
                  sx={{
                    p: 0,
                    color: 'text.secondary',
                    height: '30px',
                    width: '30px',
                    marginTop: '5px',
                  }}
                >
                  <Iconify icon="ci:show" width={16} />
                </IconButton>
              </div>
              <Divider />
            </Fragment>
          ))}
        </AccordionDetails>
      </Accordion>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full overflow-scroll flex flex-col items-center justify-center">
            <Box className="flex h-full flex-col w-full">
              <AloneHeader isIndicateur={true} isVolet={isVolet} />

              <div className="flex w-[max-content] min-h-[140px] h-[max-content]">
                <div className="w-[80px]  border-r-2 flex items-center justify-center text-md font-bold">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'voletv' : 'voletp'} />
                </div>

                <div className="w-[80px]   border-r-2 flex items-center justify-center text-md font-bold">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'nbExtraV' : 'nbExtra'} />
                </div>
                <div
                  style={{
                    width: isVolet ? '250px' : '250px',
                  }}
                  className=" font-bold  border-r-2 flex-col pl-[2px]  flex items-center justify-center text-md "
                >
                  <AreaEditMetrics
                    data={targetMetric}
                    keys={isVolet ? 'indicProgV' : 'indicProg'}
                  />{' '}
                </div>
                <div className="w-[800px] flex-col  border-r-2 pl-[2px]  flex items-center justify-center text-md ">
                  <AreaEditMetrics
                    data={targetMetric}
                    keys={isVolet ? 'contribSntev' : 'contribSnte'}
                  />
                </div>
                <div className="w-[250px] font-bold border-r-2 flex-col pl-[2px]  flex items-center justify-center text-md ">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'sourceV' : 'source'} />
                </div>
              </div>
            </Box>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openProduct}
        onClose={() => setOpenProduct(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full  overflow-scroll flex flex-col items-center justify-center">
            <Box className="flex h-[max-content] flex-col w-[max-content]">
              <AloneHeader isVolet={isVolet} />

              <div className="flex w-[max-content] bg-[#B2D4FB] h-[max-content]">
                {/* <div className="w-[120px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                <div className="w-full px-[5px] h-full min-h-[40px] flex items-center justify-center text-md capitalize-first">
                  <span className="break-words  w-[1100px]  text-wrap">{extraData}</span>
                </div>
              </div>
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default RowProduct;
